import React from 'react'
import { Helmet } from 'react-helmet-async'

import WhoHero from '../Components/who/WhoHero'
import ClientsSection from '../Components/Clients/ClientsSection'
import ClientImpactSection from '../Components/Clients/ClientImpactSection'
import ClientApproachSection from '../Components/Clients/ClientApproachSection'

function Clients() {
    return (
        <div>

            <Helmet>

                <title>
                    Our Clients | Trusted Technology & Digital Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Explore Mobikode's client partnerships and discover how businesses work with us to build digital products, automate operations, modernize technology, and create scalable solutions."
                />

                <meta
                    name="keywords"
                    content="Mobikode Clients, Mobikode Client Portfolio, Technology Clients, Digital Transformation Clients, Software Development Clients, Enterprise Technology Solutions, AI Automation Clients, ServiceNow Clients, Cloud Engineering Clients, Digital Product Development, Technology Consulting"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/clients"
                />

                {/* Open Graph */}

                <meta
                    property="og:title"
                    content="Our Clients | Trusted Technology & Digital Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Discover the businesses that trust Mobikode for digital products, technology solutions, automation, cloud engineering, and enterprise transformation."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/clients"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/product/whoweare.png"
                />

                {/* Twitter */}

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Our Clients | Trusted Technology & Digital Solutions | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="See how businesses partner with Mobikode to build digital products, improve operations, modernize technology, and create scalable solutions."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/product/whoweare.png"
                />

            </Helmet>


            <WhoHero
                title="Our Clients"
                text="Trusted by Businesses. Built for Growth."
                imgData="/assets/product/whoweare.png"
            />

            <ClientsSection />

            <ClientImpactSection />

            <ClientApproachSection />

        </div>
    )
}

export default Clients